import { memo, useEffect, useState } from "react";

import { classNames } from "shared/lib/classNames/classNames";

import cls from "./SociometryClassesList.module.scss";
import axios from "axios";
import { Layout } from "components/Layout";
import { BackButton } from "components/BackButton";
import { Link, useParams } from "react-router-dom";
import { IClass, IClassWithStatus } from "shared/types/class";
import { ISchool } from "shared/types/schooll";
import { sociometrySessionStatusMap } from "pages/sociometry/helpers/sociometrySessionStatusMap";

interface SociometryClassesListProps {
    className?: string;
}

export const SociometryClassesList = memo((props: SociometryClassesListProps) => {
    const { className } = props;

    const { id: schoolId } = useParams<{ id: string }>();

    const [classes, setClasses] = useState<IClassWithStatus[]>([]);
    const [school, setSchool] = useState<ISchool | null>(null);
    useEffect(() => {
        (async () => {
            const { data } = await axios.get<{ school: ISchool; classes: IClassWithStatus[] }>(
                `sociometry/psych/school/${schoolId}/classes`,
            );
            setClasses(data.classes);
            setSchool(data.school);
        })();
    }, [schoolId]);

    return (
        <Layout>
            <div className={classNames(cls.sociometryClassesList, {}, [className])}>
                <header className={cls.header}>
                    <BackButton />
                    <p className={cls.title}>{school?.name}</p>
                </header>

                <div className={cls.classesList}>
                    {classes.map((schoolClass) => (
                        <Link
                            key={schoolClass.class._id}
                            className={cls.class}
                            to={`/sociometry/results/${schoolClass.sessionId}`}
                        >
                            <div>
                                <p className={cls.schoolClass}>
                                    Класс: {schoolClass.class.number}
                                    {schoolClass.class.letter}
                                </p>
                                <p className={cls.startDate}>
                                    Дата назначения:{" "}
                                    <span className={cls.statusValue}>
                                        {new Date(schoolClass.createdAt).toLocaleDateString()}
                                    </span>
                                </p>
                            </div>
                            <p className={cls.status}>
                                Статус:{" "}
                                <span className={cls.statusValue}>
                                    {sociometrySessionStatusMap[schoolClass.status]}
                                </span>
                            </p>
                            <p className={cls.pupilsCount}>
                                Прошли тестирование:{" "}
                                <span className={cls.statusValue}>{schoolClass.completionRate}</span>
                            </p>
                        </Link>
                    ))}
                </div>
            </div>
        </Layout>
    );
});

SociometryClassesList.displayName = "SociometryClassesList";
